<template>
  <nav class="level app-levelbar">
    <div class="level-left">
      <div class="level-item">
        <h2 class="subtitle is-10 level-title">
          <strong>{{ name }}</strong>
        </h2>
      </div>
    </div>

    <div class="level-right is-hidden-mobile">
      <breadcrumb :list="list"></breadcrumb>
    </div>
  </nav>
</template>

<script>
import Breadcrumb from 'vue-bulma-breadcrumb'
import Tooltip from 'vue-bulma-tooltip'
import { mapGetters } from 'vuex';

export default {
  components: {
    Breadcrumb,
    Tooltip
  },

  data () {
    return {
      list: null
    }
  },

  created () {
    this.getList()
  },

  computed: {
    ...mapGetters({
      showing: "allowanceSwitch"
    }),
    name () {
      let allowanceTitile = [
        ['Family Allowance List', 'Position Allowance List'],
        ['Add Family Allowance', 'Add Position Allowance'],
        ['Draft Family Allowance List', 'Draft Position Allowance List'],
        ['Family Allowance Setting', 'Position Allowance Setting'],
      ]
      if (this.$route.path.includes('allowance')) {
        if (this.$route.name === 'View List' && this.showing === 'family') {
          return allowanceTitile[0][0]
        } else if (this.$route.name === 'View List' && this.showing === 'position') {
          return allowanceTitile[0][1]
        } else if (this.$route.name === 'Add New' && this.showing === 'family') {
          return allowanceTitile[1][0]
        } else if (this.$route.name === 'Add New' && this.showing === 'position') {
          return allowanceTitile[1][1]
        } else if (this.$route.name === 'View Draft' && this.showing === 'family') {
          return allowanceTitile[2][0]
        } else if (this.$route.name === 'View Draft' && this.showing === 'position') {
          return allowanceTitile[2][1]
        } else if (this.$route.name === 'Setting' && this.showing === 'family') {
          return allowanceTitile[3][0]
        } else if (this.$route.name === 'Setting' && this.showing === 'position') {
          return allowanceTitile[3][1]
        } 
      }
      return this.$route.name
    },
  },

  methods: {
    getList () {
      let matched = this.$route.matched.filter(item => item.name)
      let first = matched[0]
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched)
      }
      this.list = matched
    }
  },

  watch: {
    $route () {
      this.getList()
    }
  }
}
</script>
<style lang="scss">
.level-title {
  font-size: 2.5rem !important;
}
</style>



// WEBPACK FOOTER //
// Levelbar.vue?fc32595e